module.exports = __webpack_public_path__ + "static/media/sell_invoice_2.97d914fa.jpg";